import React from "react";
import ContactSection from "../components/ContactSection";

const ContactPage = () => {
  return (
    <>
      <ContactSection />
    </>
  );
};

export default ContactPage;
